import { get, post, put, del } from "@/shared/api/api-client";
import { injectable } from "inversify";
import { IBuyerReceivingPoint } from "../ts";

@injectable()
export class BuyerAccountPointsService {
    async getBuyerPointInfo(id: number) {
        const res = await get(`${PUBLIC_API_URL}/buyerpoint/${id}`);
        return res;
    }
    async getAllPointsInfo() {
        const res = await get(`${PUBLIC_API_URL}/buyerpoint`);
        return res;
    }
    async createNewPoint(dto: Omit<IBuyerReceivingPoint, 'id'>) {
        const res = await post(`${PUBLIC_API_URL}/buyerpoint`, { ...dto });
        return res;
    }
    async switchBuyerPoint({id, enabled} :{ id: number, enabled: 1 | 0 }) {
        const res = await put(`${PUBLIC_API_URL}/buyerpoint/${id}`, { enabled });
        return res;
    }
    async updatePointInfo(dto: IBuyerReceivingPoint) {
        const res = await put(`${PUBLIC_API_URL}/buyerpoint/${dto.id}`, { ...dto });
        return res;
    }
    async deletePoint(id: number) {
        const res = await del(`${PUBLIC_API_URL}/buyerpoint/${id}`);
        return res;
    }
}